'use strict';

function LicensesEnvironmentalController($rootScope, $scope, objectMakerFactory, dataHolderFactory, dataRequestService, usSpinnerService) {
  var self = this;

  this.getLicensesEnvironmental = function () {
    var contractId = dataHolderFactory.getSavedContractDetails().id;
    usSpinnerService.spin('spinner-1');
    dataRequestService.getLicensesEnvironmental(contractId).then(function (result) {
      usSpinnerService.stop('spinner-1');
      $scope.licensesEnvironmentalViewControl.licenses = result;
    }, function (error) {
      usSpinnerService.stop('spinner-1');
      console.log(error);
    });
  };

  $scope.initLicensesEnvironmentalController = function () {
    $scope.licensesEnvironmentalViewControl = objectMakerFactory.viewObjectControlForLicensesEnvironmental();
    self.getLicensesEnvironmental();
  };

  $scope.restoreViewControl = function () {
    $rootScope.appControl.showLicencesEnvironmental = false;
  };
}

LicensesEnvironmentalController.$inject = ['$rootScope', '$scope', 'objectMakerFactory', 'dataHolderFactory', 'dataRequestService', 'usSpinnerService']
export default LicensesEnvironmentalController



// WEBPACK FOOTER //
// ./src/app/scripts/controllers/licensesEnvironmentalController.js